// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep as-split-gutter {
  height: initial !important;
}

.field-json-config {
  margin: 10px 30px 0 30px;
}
.field-json-config mat-error {
  font-size: 12px;
}
.field-json-config button {
  margin: 20px 0 0 0;
  width: 150px;
}
.field-json-config textarea {
  height: 300px;
  width: 300px;
}

.dynamic-form {
  margin: 10px 30px 0 30px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/form-performance/form-performance.component.scss","webpack://./../mydocma-dynamic-form-app%20(dev)/src/app/components/form-performance/form-performance.component.scss"],"names":[],"mappings":"AACI;EAAkB,0BAAA;ACCtB;;ADEA;EACI,wBAAA;ACCJ;ADCI;EACI,eAAA;ACCR;ADEI;EACI,kBAAA;EACA,YAAA;ACAR;ADGI;EACI,aAAA;EAAe,YAAA;ACAvB;;ADIA;EACI,wBAAA;ACDJ","sourcesContent":["::ng-deep {\r\n    as-split-gutter { height: initial !important; }\r\n}\r\n\r\n.field-json-config {\r\n    margin: 10px 30px 0 30px;\r\n\r\n    mat-error {\r\n        font-size: 12px;\r\n    }\r\n\r\n    button {\r\n        margin: 20px 0 0 0;\r\n        width:150px;\r\n    }\r\n\r\n    textarea{\r\n        height: 300px; width: 300px;\r\n    }\r\n}\r\n\r\n.dynamic-form {\r\n    margin: 10px 30px 0 30px;\r\n}\r\n","::ng-deep as-split-gutter {\n  height: initial !important;\n}\n\n.field-json-config {\n  margin: 10px 30px 0 30px;\n}\n.field-json-config mat-error {\n  font-size: 12px;\n}\n.field-json-config button {\n  margin: 20px 0 0 0;\n  width: 150px;\n}\n.field-json-config textarea {\n  height: 300px;\n  width: 300px;\n}\n\n.dynamic-form {\n  margin: 10px 30px 0 30px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
